import React, { Component } from "react";
import "./Grid.css";
import Pagination from "../../../HSGPagination/HSGPagination";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import CONSTANTS from "../../../../Phi/Constants";
import "react-datepicker/dist/react-datepicker.css";
import "react-select/dist/react-select.css";
import history from "../../../../history";
import cbsereport from "../../../DashboardContainer/Component/NewUiimg/CBSEreport.png";
import growthreport from "../../../DashboardContainer/Component/NewUiimg/Growthreport.png";
import physicalreport from "../../../DashboardContainer/Component/NewUiimg/physicalreport.png";
import eyereport from "../../../DashboardContainer/Component/NewUiimg/eyereport.png";
import entreport from "../../../DashboardContainer/Component/NewUiimg/ENTreport.png";
import dentalreport from "../../../DashboardContainer/Component/NewUiimg/dentalreport.png";
import "./HSGSTUDENTGrid.css";
import upar from "../../../DashboardContainer/Component/NewUiimg/upar.png";

import { REPORT_TYPES } from "../../../../utils/helpers/reportNavigation";
import HSGPopupContainer from "../../../HSGPopup/HSGPopupComponent";
import EpisodeForm from "../../../SmartClinicContainer/Component/Episode/EpisodeForm";
import { PALLETTE } from "../../../../utils/theme";
import stuicon from "../../../DashboardContainer/Component/NewUiimg/stu_listicon.png";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

class HSGStudentGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxStates: "",
      numberEntered: 0,
      checkedRowColorChange: "rgb(239, 245, 254);",
      currentPageItems: [],
      currentPage: 1,
      itemsPerPage: 7,
      refreshCount: 0,
      data: this.formatData(props.data || []),
      studentArr: [],
      showConfirmationModal: false,
      selectedClass: null,
      selectedStatus: null,
      inSearchString: "",
      selectedStudentType: null,
      selectedAll: {},
      selectAllCheck: false,
      checkItems: [],
      showEpisodeModal: false,
      selectedEpisodeStudent: null,
      isOpen: false,
      currSizePerPage: "5",
      parameters: {
        pageNum: 1,
        length: 5,
      },
      total: props.total,
      showEditStudentModal: false,
      editableRow: {},
    };
  }

  handleClick = (item) => {
    this.props.setSelectedStudent(item);
    sessionStorage.setItem("student", JSON.stringify(item));
    history.push("/student-profile");
  };
  initializeTooltips = () => {
    const disabledButtons = document.querySelectorAll(
      ".add-episode-disabled-tooltip",
    );

    disabledButtons.forEach((element) => {
      if (!element._tippy) {
        tippy(element, {
          content: "User Not Allowed",
          placement: "top",
          arrow: true,
          delay: [100, 0],
          theme: "hsg-tooltip",
        });
      }
    });
  };

  renderReportDropdown = (item) => {
    if (item.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED) {
      return (
        <ul
          className="dropdown-menu shadow"
          aria-labelledby={`dropdownMenuButton-${item.uuid}`}
          style={{
            cursor: "pointer",
            border: "1px solid rgba(30, 135, 240, 0.4)",
            borderRadius: ".5rem",
            padding: "8px 0",
            minWidth: "150px",
          }}
        >
          <li
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() =>
              this.props.downloadStudentReport(
                item.uuid,
                item.studentname,
                item.studentId,
                "cbsereport",
              )
            }
          >
            <img
              src={cbsereport}
              style={{ width: "18px", marginRight: "10px" }}
              alt="CBSE Report"
            />
            <span style={{ fontSize: "10px", fontWeight: 500 }}>
              CBSE REPORT
            </span>
          </li>
          <hr className="my-1 opacity-25" />
          <li
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() => this.handleReportNavigation(item, "Growth", 2)}
          >
            <img
              src={growthreport}
              style={{ width: "18px", marginRight: "10px" }}
              alt="Growth Report"
            />
            <span style={{ fontSize: "10px", fontWeight: 500 }}>
              GROWTH REPORT
            </span>
          </li>
          <hr className="my-1 opacity-25" />
          <li
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() => this.handleReportNavigation(item, "Physical", 5)}
          >
            <img
              src={physicalreport}
              style={{ width: "18px", marginRight: "10px" }}
              alt="Physical Report"
            />
            <span style={{ fontSize: "10px", fontWeight: 500 }}>
              PHYSICAL REPORT
            </span>
          </li>
          <hr className="my-1 opacity-25" />
          <li
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() => this.handleReportNavigation(item, "Eye", 4)}
          >
            <img
              src={eyereport}
              style={{ width: "18px", marginRight: "10px" }}
              alt="Eye Report"
            />
            <span style={{ fontSize: "10px", fontWeight: 500 }}>
              EYE REPORT
            </span>
          </li>
          <hr className="my-1 opacity-25" />
          <li
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() => this.handleReportNavigation(item, "ENT", 3)}
          >
            <img
              src={entreport}
              style={{ width: "18px", marginRight: "10px" }}
              alt="ENT Report"
            />
            <span style={{ fontSize: "10px", fontWeight: 500 }}>
              ENT REPORT
            </span>
          </li>
          <hr className="my-1 opacity-25" />
          <li
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() => this.handleReportNavigation(item, "Dental", 6)}
          >
            <img
              src={dentalreport}
              style={{ width: "18px", marginRight: "10px" }}
              alt="Dental Report"
            />
            <span style={{ fontSize: "10px", fontWeight: 500 }}>
              DENTAL REPORT
            </span>
          </li>
        </ul>
      );
    }

    return (
      <ul
        className="dropdown-menu shadow-sm"
        aria-labelledby={`dropdownMenuButton-${item.uuid}`}
        style={{ minWidth: "120px", padding: "8px 0" }}
      >
        <li
          className="dropdown-item text-muted text-center py-1"
          style={{ fontSize: "10px" }}
        >
          NA
        </li>
      </ul>
    );
  };

  async handleReportNavigation(item, type, activityId) {
    const currentAssessment = this.props.assessmentStatus?.find(
      (status) => status.in_activity_id === Number(activityId),
    );

    if (currentAssessment && currentAssessment.remarks) {
      try {
        const parsedRemarks = JSON.parse(currentAssessment.remarks);
        if (parsedRemarks.key === 105) {
          this.setState({
            showCustomAlert: true,
            customAlertMessage: parsedRemarks?.value,
          });

          setTimeout(() => {
            this.setState({ showCustomAlert: false, customAlertMessage: "" });
          }, 4000);

          return;
        }
      } catch (error) {
        console.error(error);
      }
    }

    const reportConfig = REPORT_TYPES.find(
      (option) => option.label.toLowerCase() === type.toLowerCase(),
    );

    if (reportConfig) {
      const navigationState = {
        ...item,
        eventTrackId: this.props.startNodeId,
        activityId: reportConfig.value,
      };

      sessionStorage.setItem(
        "report_navigation_state",
        JSON.stringify(navigationState),
      );
      window.open(reportConfig.pathname, "_blank");
    } else {
      window.open(
        `/report/student/${this.props.startNodeId}/${type.toLowerCase()}/${item.uuid}`,
        "_blank",
      );
    }
  }

  handleCheckboxChange = (e, item) => {
    let index = this.state.data.findIndex(
      (object) => object.uuid === item.uuid,
    );
    let checkArray = [...this.state.checkItems];
    checkArray[index] = e.target.checked;
    this.setState({ checkItems: checkArray });
    this.props.onSelect(item, e.target.checked, e);
  };

  handleCheckbox = (e) => {
    let checked = [];
    if (!e.target.checked) {
      checked = Array(this.state.data.length).fill(false);
    } else {
      checked = [...this.state.checkItems];
      for (let i = 0; i < this.state.itemsPerPage; i++) {
        checked[i] = e.target.checked;
      }
    }
    this.setState({ selectAllCheck: e.target.checked, checkItems: checked });
    this.props.onSelectAll(e.target.checked, this.state.data);
  };

  openEpisodeModal = (student) => {
    this.setState({
      selectedEpisodeStudent: student,
      showEpisodeModal: true,
    });
  };

  closeEpisodeModal = () => {
    this.setState({
      selectedEpisodeStudent: null,
      showEpisodeModal: false,
    });
  };

  closeEpisodeForm = () => {
    this.closeEpisodeModal();
    this.props.refreshStudentList && this.props.refreshStudentList();
  };

  getAgeInMonths = (dateOfBirth) => {
    if (!dateOfBirth) return 0;
    const ageDate = new Date(Date.now() - new Date(dateOfBirth).getTime());
    if (Number.isNaN(ageDate.getTime())) return 0;

    return parseInt(
      (ageDate.getUTCFullYear() - 1970 + "." + ageDate.getUTCMonth()) * 12,
      10,
    );
  };

  renderEpisodeModal = () => {
    const student = this.state.selectedEpisodeStudent;
    if (!this.state.showEpisodeModal || !student) return null;

    return (
      <HSGPopupContainer
        show={this.state.showEpisodeModal}
        header={`Add Episode - ${student.studentname}`}
        onHide={this.closeEpisodeModal}
        body={
          <EpisodeForm
            initializeForm={this.props.initializeForm}
            toggleModal={this.closeEpisodeModal}
            toggleEpisodeModal={this.closeEpisodeModal}
            onClose={this.closeEpisodeModal}
            postEpisode={(customJson, episodeType) =>
              this.props.postStudentEpisodeInfo(
                student.user_id,
                customJson,
                episodeType,
              )
            }
            closeEpisodeForm={this.closeEpisodeForm}
            metaData={this.props.metaData}
            age={this.getAgeInMonths(student.dob)}
            clearForm={this.props.clearForm}
          />
        }
      />
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) {
      let checkArray = Array(this.state.data.length).fill(false);
      this.setState({ checkItems: checkArray, selectAllCheck: false });
    }
    this.initializeTooltips();
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) ||
      this.props.total !== nextProps.total
    ) {
      this.setState({
        data: this.formatData(nextProps.data),
        total: nextProps.total,
      });
    }
    if (nextProps.inSearchString !== this.state.inSearchString) {
      this.setState({ inSearchString: nextProps.inSearchString });
    }
  }

  formatData = (data) => {
    if (!data) return [];
    const genderMap = { M: "MALE", F: "FEMALE", O: "OTHER" };
    return data.map((d) => ({
      uuid: d.hsg_id,
      studentname: `${d.firstname || ""} ${d.lastname || ""}`.trim() || "NA",
      class: d.class || "NA",
      section: d.section || "NA",
      gender: genderMap[d.gender] || d.gender || "NA",
      dob: d.dob || "NA",
      user_id: d.user_id,
      student_id: d.student_id,
      admission_number: d.admission_number || "NA",
      authenticationcode: d.authentication_code || "NA",
      status: d.report_status,
    }));
  };

  getData = (data = []) => {
    return data.map((item, index) => ({
      ...item,
      index: (this.props.offset || 0) + 1 + index,
    }));
  };

  editStudentDetail = (row = {}) => {
    this.setState({
      showEditStudentModal: !this.state.showEditStudentModal,
      editableRow: { ...row },
    });
  };

  renderPaginationPanel = (props) => {
    const { data, total } = this.state;
    const { offset, showNext } = this.props;
    return (
      <Pagination
        inOffset={offset}
        showNext={showNext}
        data={data}
        total={total}
        className={"right padding-right-3rem"}
      />
    );
  };

  createRow = (item, id) => {
    const isChecked = Boolean(this.state.checkItems[id]);

    return (
      <div
        key={item.uuid}
        className="d-flex align-items-center mb-2 px-3 py-2"
        style={{
          backgroundColor: "#eff5fe",

          minHeight: "84px",
        }}
      >
        <div
          className="d-flex align-items-center"
          style={{ flex: "0 0 32%", minWidth: 0, paddingRight: "16px" }}
        >
          {this.props.show && this.props.show !== false && (
            <input
              type="checkbox"
              className="form-check-input me-3"
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
                flexShrink: 0,
              }}
              checked={isChecked}
              onChange={(e) => this.handleCheckboxChange(e, item)}
            />
          )}

          <div
            className="d-flex flex-column"
            style={{ minWidth: 0, width: "100%" }}
          >
            <span
              className="text-truncate fw-bold text-dark"
              style={{ fontSize: "12px", marginBottom: "4px" }}
              title={item.studentname}
            >
              {item.studentname}
            </span>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "16px",
                rowGap: "2px",
                fontSize: "10px",
              }}
              className="text-muted"
            >
              <div>
                Admin No. :{" "}
                <span style={{ fontWeight: 600, color: "#495057" }}>
                  {item.admission_number}
                </span>
              </div>
              <div>
                Gender:{" "}
                <span style={{ fontWeight: 600, color: "#495057" }}>
                  {item.gender}
                </span>
              </div>
              <div>
                D.O.B:{" "}
                <span style={{ fontWeight: 600, color: "#495057" }}>
                  {item.dob}
                </span>
              </div>
              <div>
                Class:{" "}
                <span style={{ fontWeight: 600, color: "#495057" }}>
                  {item.class}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          className="d-flex align-items-center"
          style={{ flex: "0 0 18%", minWidth: 0, paddingRight: "12px" }}
        >
          <span
            className="text-truncate font-monospace"
            style={{ fontSize: "13px", color: "#2c3e50", fontWeight: 600 }}
            title={item.uuid}
          >
            {item.uuid}
          </span>
        </div>

        <div
          className="d-flex align-items-center"
          style={{ flex: "0 0 22%", minWidth: 0, paddingRight: "12px" }}
        >
          <span
            className="text-truncate font-monospace"
            style={{
              fontSize: "13px",
              color: "#495057",
              letterSpacing: "0.5px",
            }}
            title={item.authenticationcode}
          >
            {item.authenticationcode}
          </span>
        </div>

        <div
          className="d-flex align-items-center justify-content-center"
          style={{ flex: "0 0 10%" }}
        >
          <button
            type="button"
            className="list_btn"
            onClick={() => this.handleClick(item)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              height: "30px",
              width: "auto",
              gap: " 4px",
              mwidth: "80px",
              fontWeight: 600,
              padding: "0 14px",

              fontSize: "1.1rem",

              borderRadius: ".5rem",
              cursor: "pointer",
            }}
          >
            <img
              style={{ height: "15px", width: "15px" }}
              src={stuicon}
              alt="Student Icon"
            />
            VIEW
          </button>
        </div>

        <div
          className="d-flex align-items-center justify-content-center position-relative"
          style={{ flex: "0 0 18%" }}
        >
          {this.props.show && this.props.show !== false ? (
            item.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED ? (
              <div className="dropdown">
                <button
                  className="list_btn drpbtn d-flex align-items-center justify-content-center"
                  type="button"
                  id={`dropdownMenuButton-${item?.uuid}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    height: "30px",
                    padding: "0 14px",
                    fontSize: "1.1rem",
                    borderRadius: ".5rem",
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  <span>VIEW REPORT</span>
                  <img
                    className="upepisodearrow"
                    src={upar}
                    style={{ marginLeft: "8px", width: "16px", height: "16px" }}
                    alt="Up Arrow"
                  />
                </button>
                {this.renderReportDropdown(item)}
              </div>
            ) : (
              <span
                className="forNA"
                style={{ fontSize: "10px", fontWeight: 600 }}
              >
                NA
              </span>
            )
          ) : (
            <div>
              {this.props.showAddEpisodeButton ? (
                <button
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "30px",
                    padding: "0 14px",
                    fontSize: "1.2rem",
                    borderRadius: ".5rem",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                  className="list_btn"
                  onClick={() => this.openEpisodeModal(item)}
                >
                  Add Episode
                </button>
              ) : (
                <div
                  className="add-episode-disabled-tooltip"
                  style={{
                    display: "inline-flex",
                    cursor: "not-allowed",
                  }}
                >
                  <button
                    disabled
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "30px",
                      padding: "0 14px",
                      fontSize: "1.2rem",
                      borderRadius: ".5rem",
                      backgroundColor: PALLETTE.chip,
                      borderColor: PALLETTE.gray,
                      color: PALLETTE.gray,
                      cursor: "not-allowed",
                      pointerEvents: "none",
                    }}
                    className="list_btn"
                  >
                    Add Episode
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const { uuid, studentname, phone, authenticationcode } =
      this.state.editableRow;

    return (
      <div className="w-100 px-3 py-2">
        <div
          className="d-flex align-items-center px-3 py-3 mb-2"
          style={{
            backgroundColor: "#fff",
            borderBottom: "2px solid #e2e8f0",
            fontWeight: 700,
            fontSize: "10px",
            color: "#475569",
            letterSpacing: "0.5px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ flex: "0 0 32%", minWidth: 0, paddingRight: "16px" }}
          >
            {this.props.show && this.props.show !== false && (
              <input
                type="checkbox"
                className="form-check-input me-3"
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                  flexShrink: 0,
                }}
                id="flexCheckDefault"
                checked={this.state.selectAllCheck}
                onChange={(e) => this.handleCheckbox(e)}
              />
            )}
            <span>BASIC INFO</span>
          </div>

          <div style={{ flex: "0 0 18%", minWidth: 0, paddingRight: "12px" }}>
            HSG-ID
          </div>

          <div style={{ flex: "0 0 22%", minWidth: 0, paddingRight: "12px" }}>
            AUTHENTICATION CODE
          </div>

          <div className="" style={{ flex: "0 0 10%", paddingLeft: "1.2rem" }}>
            PROFILE
          </div>

          <div
            style={{
              flex: "0 0 18%",

              paddingLeft: "1.8rem",
            }}
          >
            {this.props.show && this.props.show !== false
              ? "VIEW REPORTS"
              : "ADD EPISODE"}
          </div>
        </div>

        <div className="student-rows-container">
          {this.getData(this.state.data).map((item, id) =>
            this.createRow(item, id),
          )}
        </div>

        {this.renderPaginationPanel(this.props)}
        {this.renderEpisodeModal()}

        <Modal
          show={this.state.showEditStudentModal}
          backdrop={true}
          animation={true}
          bsSize={"large"}
          dialogClassName={"student-edit-modal"}
          onHide={() => this.editStudentDetail()}
        >
          <Modal.Header bsClass={"student-edit-modal-hd"}>
            <Modal.Title>Edit mode</Modal.Title>
            <span
              onClick={() => this.editStudentDetail()}
              aria-hidden="true"
              data-icon="&#e90b;"
              className="icon-close hsg-icon-close"
            ></span>
          </Modal.Header>

          <Modal.Body bsClass={"student-edit-modal-bd"}>
            <div className="row">
              <div className="hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                <label className="hsg-input-label">HSG ID</label>
                <input
                  disabled
                  className="hsg-input"
                  type="text"
                  value={uuid || ""}
                />
              </div>
              <div className="right hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                <label className="hsg-input-label">AUTHENTICATION CODE</label>
                <input
                  className="hsg-input"
                  type="text"
                  value={authenticationcode || ""}
                />
              </div>
              <div className="hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                <label className="hsg-input-label">STUDENT NAME</label>
                <input
                  className="hsg-input"
                  type="text"
                  value={studentname || ""}
                />
              </div>
              <div className="right hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                <label className="hsg-input-label">CONTACT NUMBER</label>
                <input className="hsg-input" type="text" value={phone || ""} />
              </div>
              <div className="hsg-input-grp date-icon col-md-5 col-xs-12 col-lg-5 col-sm-12">
                <label className="hsg-input-label">REMINDER</label>
                <DatePicker
                  className="hsg-input-date"
                  selected={moment()}
                  onChange={this.handleChange}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="DD/MM/YYYY"
                  calendarClassName="datepicker-calendar"
                />
              </div>
              <div className="right hsg-input-grp col-md-5 col-xs-12 col-lg-5 col-sm-12">
                <label className="hsg-input-label">REMARKS</label>
                <input className="hsg-input" type="text" defaultValue="" />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer bsClass={"student-edit-modal-ft"}>
            <span
              className="cursor-pointer"
              onClick={() => this.editStudentDetail()}
            >
              Cancel
            </span>
            &nbsp; &nbsp; &nbsp;
            <button className="hsg-btn">Save</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default HSGStudentGrid;
